<div>
  @if (openCloseVariant) {
    <div class="open-close-container">
      <div class="search"
                 [ngClass]="{
                        'open'   : searchIsOpen,
                        'closed' : navigationIsCollapsed
                    }">
        <button (click)="openCloseSearch()" class="search-icon">
          <span appIcon="search"></span>
        </button>
        <div [cdkMenuTriggerFor]="(searchService.onSearchPage$ | async) ? noSearch : searchResults"
          class="search-input"
          >
          <input [formControl]="search"
            (blur)="onBlur()"
            (keydown.space)="$event.stopPropagation();"
            (keydown.enter)="navigateToSearch()"
            type="search"
            placeholder="{{'navigation.looking-for' | translate}}"
            #openCloseInput
            />
        </div>
        <button (click)="openCloseSearch()" class="close-icon">
          <span appIcon="close"></span>
        </button>
      </div>
    </div>
  }

  @if (! openCloseVariant) {
    <app-input [control]="search"
      [cdkMenuTriggerFor]="(searchService.onSearchPage$ | async) ? undefined : searchResults"
      (blur)="onBlur()"
      (keydown.enter)="navigateToSearch()"
      placeholder="{{'navigation.looking-for' | translate}}"
      icon="search"
      theme="search"
      size="smaller"
      class="block-page-scroll-on-focus"
    ></app-input>
  }

  <ng-template #searchResults>
    @if (inputStopped && search.value) {
      <div
        cdkMenu
        class="search-container"
        >
        <div class="results" [ngClass]="search.value.length < 3 ? 'recent' : ''">
          @if (search.value.length >= 3) {
            @if (loading$ | async) {
              <ng-container [ngTemplateOutlet]="loading"></ng-container>
            }
            @if (instantSearchConfig$ | async; as isConfig) {
              @if (productSearchParameters$ | async; as searchParams) {
                <app-instantsearch [config]="isConfig">
                  @if (searchParams) {
                    <app-instantsearch-configure
                      [searchParameters]="searchParams"
                    ></app-instantsearch-configure>
                  }
                  <app-search-hits-products (resultClicked)="resultClicked()"
                    (loading)="onLoading('products', $event)"
                  ></app-search-hits-products>
                </app-instantsearch>
              }
              @if (otherInstantSearchConfig$ | async; as otherConfig) {
                @if (otherSearchParameters; as searchParams) {
                  <app-instantsearch [config]="otherConfig">
                    @if (searchParams) {
                      <app-instantsearch-configure
                        [searchParameters]="searchParams"
                      ></app-instantsearch-configure>
                    }
                    <app-search-hits-other (resultClicked)="resultClicked()"
                      (loading)="onLoading('other', $event)"
                    ></app-search-hits-other>
                  </app-instantsearch>
                }
              }
              <div class="search-results-footer">
                <a [routerLink]="'/search' | translateRoute"
                  (click)="onBlur()"
                  class="search-results-footer-link"
                  >
                  {{ 'search.show-all-results' | translate }}
                </a>
              </div>
            }
          } @else {
            @if (recentSearches?.length) {
              <div class="title">
                <h4>{{ 'search.recently-searched' | translate }}</h4>
              </div>
              <div class="results-container">
                @for (recent of recentSearches; track recent) {
                  <div
                    class="recent-search"
                    [routerLink]="'/products/' + recent.slug | translateRoute"
                    (click)="onBlur(true)"
                    >
                    {{ recent.name | lowercase }}
                  </div>
                }
              </div>
            }
          }
        </div>
      </div>
    }
  </ng-template>
</div>


<ng-template #loading>
  <app-page-spinner></app-page-spinner>
</ng-template>

<ng-template #noSearch>
</ng-template>
